<div class="report-container occupancy-rental" [class.display-none]="showPropertyDetails">
    <!-- Menu -->
    <app-report-sub-menu *ngIf="!showPropertyDetails" [menuList]="overViewMenu" (menuChangeValue)="menuChangeValue($event)"
    [activeTab]="activeTab" [activeTabName]="activeTabName"></app-report-sub-menu>
    <!-- Overview -->
    <ng-container *ngIf="overviewAverageLoading">
        <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"></app-skeleton-loader>
    </ng-container>
    <div class="report-tabsection" id="{{ occupancyRentalMenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === occupancyRentalMenuEnum.overview}">
        <div class="report-overview report-overview-2col" *ngIf="!overviewAverageLoading">

      <app-overview-card
        [card_title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annualAverageRentRateGradeWise':'reports.averageRentRateGradeWise'"
        [uniType]="UnitTypeEnum.currencywithsqm" [propertiesCount]="averageData?.total_properties"
        [graphData]="{data: averageGradeData, type: 'averageRentRate'}"
        [untillDate]="averageData?.untillDate"
        [minDate]="averageData?.min_date"
        [maxDate]="averageData?.max_date"
        [gradeWise]="true"></app-overview-card>
      <app-overview-card [card_title]="isSaudiCheck ? 'reports.topNeighborhoods' : 'reports.occupancy_rate'" [card_sub_title] = "'reports.based_on_select_properties'" [showTooltip] = "isSaudiCheck ? false : true" [toolTipContent] = "'reports.propertiesProjectsCoveredEstater'" [total_current]="occupancyData?.avg_rent"
          [untillDate]="occupancyData?.untillDate"
          [minDate]="occupancyData?.min_date"
          [maxDate]="occupancyData?.max_date"
          [uniType]="isSaudiCheck ? UnitTypeEnum.currencywithsqm : UnitTypeEnum.percentage"
          [graphData]="{data: occupancyGradeData, type: 'occupancyRate'}"></app-overview-card>
        </div>
        <!-- Rent Rate Graph -->
        <div class="report-model report-rentrate" *ngIf="overviewChartData">
            <div class="report-model-header">
                <div class="info">
                    <h3>{{sharedService.priceCalculation$() === sharedService.priceYearly ? ('reports.annual_rent_rate' | translate) : ('reports.monthly_rent_rate' | translate)}} ({{CurrencyCode
                        | translate}}/{{'reports.sqm_unit' | translate}})
                    </h3>
                </div>
                <button class="btn-select-grade" [matMenuTriggerFor]="menu" *ngIf="(retailRentalChartReport | json) != '{}'">
                    <div class="setext">
                        <ng-container *ngFor="let name of selectedChartValue; let l = last">{{name}}<span *ngIf="!l"
                                style="padding-right: 2px;">,</span></ng-container>
                    </div>
                    <span class="morecount" *ngIf="selectedChartValue.length > 1">{{moreText}}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>

                <mat-menu #menu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
                    class="grades-menu directionLtr">
                    <div (click)="$event.stopPropagation()">
                        <h5>{{'reports.choose_maximum_options' | translate}}</h5>
                        <ng-container *ngFor="let category of getReportKeys()">
                            <mat-checkbox (change)="selectChart($event, category)"
                                [checked]="selectedChartValue.includes(category)">{{category}}</mat-checkbox>
                        </ng-container>
                    </div>
                </mat-menu>
            </div>
            <ng-container *ngIf="overviewGraphLoading">
                <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!overviewGraphLoading">
                <div class="multiBarChart d-flex" *ngIf="(retailRentalChartReport | json) != '{}'; else noDataMessage">
                    <!-- {{retailRentalChartReport.length}} -->
                    <ng-container *ngFor="let chart of retailRentalChartReportArray; let i = index">
                        <ng-container *ngFor="let key of getKeys(chart)">
                            <app-report-charts class="grchart" [data]="chart[key]" [chartType]="chartView.smallBarChart" [isBorder]="false"
                                [name]="key" [index]="i"
                                [ngStyle]="{'min-width': (retailRentalChartReportArray | keyvalue).length == 1 ? '100%' : '300px'}">
                            </app-report-charts>
                        </ng-container>
                    </ng-container>


                </div>
                <ng-template #noDataMessage>
                    <div class="data_unavail">
                        <span>
                            {{"reports.data_not_available" | translate}} <mat-icon  role="img" class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">equalizer</mat-icon>
                        </span>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </div>
    <!-- Residential Units - Grade wise -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === occupancyRentalMenuEnum.residentialUnitsGradeWise}"
        id="{{ occupancyRentalMenuEnum.residentialUnitsGradeWise }}">
        <app-report-year-dropdown [reportType]="'residentialGrade'"
        (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.residential_units_grade_wise'" [count]="residentialGradeUnitsCount" [countTitle]="'reports.total_units'"></app-datatable-title>
            <app-rental-unit-table
                [tableName]="'residential'"
                [showLoader]="!residentialGradeLoading"
                [tableColumns]="residentialGradeColumns" [dataLength]="residentialGradeCount"
                [tableData]="residentialGradeData"
                (pageEvent)="onPageEvent($event, occupancyRentalMenuEnum.residentialUnitsGradeWise)"
                (sort)="sortData($event, occupancyRentalMenuEnum.residentialUnitsGradeWise)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'ir_occupancy_rental_grade_wise_v2', 'a')"
                [downloadLoading]="downloadLoading['a']"></app-rental-unit-table>

        </div>
    </div>
    <!-- Residential Units - Type wise -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === occupancyRentalMenuEnum.residentialUnitsTypeWise}"
        id="{{ occupancyRentalMenuEnum.residentialUnitsTypeWise }}">
        <app-report-year-dropdown [reportType]="'residentialType'"
        (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.residential_units_type_wise'" [count]="residentialTypeUnitCount" [countTitle]="'reports.total_units'"></app-datatable-title>

            <app-rental-unit-table
                [tableName]="'residential'"
                [showLoader]="!residentialTypeLoading"
                [tableColumns]="residentialTypeColumns" [dataLength]="residentialTypeCount"
                [tableData]="residentialTypeData"
                (pageEvent)="onPageEvent($event, occupancyRentalMenuEnum.residentialUnitsTypeWise)"
                (sort)="sortData($event, occupancyRentalMenuEnum.residentialUnitsTypeWise)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'ir_occupancy_rental_type_wise_v2', 'b')"
                [downloadLoading]="downloadLoading['b']"></app-rental-unit-table>


        </div>
    </div>
    <!-- Commercial Units - Grade wise -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === occupancyRentalMenuEnum.commercialUnitsGradeWise}"
        id="{{ occupancyRentalMenuEnum.commercialUnitsGradeWise }}">
        <app-report-year-dropdown [reportType]="'commercialGrade'"
        (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.commercial_units_grade_wise'" [count]="commercialGradeUnitCount" [countTitle]="'reports.total_units'"></app-datatable-title>

              <app-rental-unit-table
                [tableName]="'commercial'"
                [showLoader]="!commercialGradeLoading"
                [tableColumns]="commercialGradeColumns" [dataLength]="commercialGradeCount"
                [tableData]="commercialGradeData"
                (pageEvent)="onPageEvent($event, occupancyRentalMenuEnum.commercialUnitsGradeWise)"
                (sort)="sortData($event, occupancyRentalMenuEnum.commercialUnitsGradeWise)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'ir_occupancy_rental_commercial_grade_wise_v2', 'c')"
                [downloadLoading]="downloadLoading['c']"></app-rental-unit-table>


        </div>
    </div>
    <!-- Commercial Units - Size wise -->
    <div class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === occupancyRentalMenuEnum.commercialUnitsSizeWise}"
        id="{{ occupancyRentalMenuEnum.commercialUnitsSizeWise }}">
        <app-report-year-dropdown [reportType]="'commercialSize'"
        (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.commercial_units_size_wise'" [count]="commercialSizeUnitCount" [countTitle]="'reports.total_units'"></app-datatable-title>

             <app-rental-unit-table
                [tableName]="'commercial'"
                [showLoader]="!commercialSizeLoading"
                [tableColumns]="commercialSizeColumns" [dataLength]="commercialSizeCount"
                [tableData]="commercialSizeData"
                (pageEvent)="onPageEvent($event, occupancyRentalMenuEnum.commercialUnitsSizeWise)"
                (sort)="sortData($event, occupancyRentalMenuEnum.commercialUnitsSizeWise)" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'ir_occupancy_rental_commercial_size_wise_v2', 'd')"
                [downloadLoading]="downloadLoading['d']"></app-rental-unit-table>


        </div>
    </div>
    <!-- Property Rental Transaction (Show only L3 Report) -->
    <div *ngIf="isPremium" class="report-tabsection"
        [ngClass]="{ 'scroll': currentScroll === occupancyRentalMenuEnum.unitRentalTransaction}"
        id="{{ occupancyRentalMenuEnum.unitRentalTransaction }}">
        <app-report-year-dropdown [reportType]="'transaction'"
        (selectedYear)="selectedYear($event)"></app-report-year-dropdown>
        <div class="report-model">

            <app-datatable-title [title]="'reports.propertyRentalTransaction'" [count]="transactionpropertiesCount" [countTitle]="'reports.totalRecords'"></app-datatable-title>

            <app-report-datatable-property-transactions [tableName]="'propertyRentalTransaction'"
                [tableColumns]="transactionColumns" [tableData]="transactionData" [dataLength]="transactionCount"
                (sort)="sortData($event, occupancyRentalMenuEnum.unitRentalTransaction)"
                (pageEvent)="onPageEvent($event, occupancyRentalMenuEnum.unitRentalTransaction)"
                [showLoader]="!transactionLoading" [allowExcelDownload]="true"
                (excelDownload)="downloadExcel($event, 'ir_occupancy_rental_property_transaction_v2', 'e')" [downloadLoading]="downloadLoading['e']"
                ></app-report-datatable-property-transactions>


        </div>
    </div>
</div>
